export default __webpack_public_path__ + "2df4ff5b65f77d319a42a13db48b42a7.svg";